export * from "ce/pages/Applications/EmbedSnippetTab";
import { default as CE_EmbedSnippetTab } from "ce/pages/Applications/EmbedSnippetTab";
export default CE_EmbedSnippetTab;
